<template>
  <div class="home-name-week" :class="[deviceType]">
    <div class="week-header">
      <div class="week-title" @click="navigateToFirstCard">Names of The Week</div>
    </div>
    <div class="week-cards" ref="weekCards">
      <router-link v-for="(card, index) in nameCards" :key="index"
        :to="`/names/${card.name.toLowerCase()}/${card.id}`" tag="div" class="name-card-link">
        <div class="name-card" :style="{ background: card.background }">
          <div class="card-header">
            <div class="card-info">
              <div class="card-name">{{ card.name }}</div>
              <div class="card-pronunciation">{{ card.pronunciation }}</div>
            </div>
            <div class="card-gender-icon">
              <img :src="card.genderIcon" alt="gender icon" />
            </div>
          </div>
          <div class="card-details-grid">
            <div class="detail-box">
              <div class="detail-value">{{ card.popularity }}</div>
              <div class="detail-label">US Popularity</div>
            </div>
            <div class="detail-box">
              <div class="detail-value">{{ card.style }}</div>
              <div class="detail-label">Style</div>
            </div>
            <div class="detail-box">
              <div class="detail-value text-ellipsis">
                <span v-for="item in card.meaningList" :key="item">{{ item }} </span></span>
              </div>
              <div class="detail-label">Meaning</div>
            </div>
          </div>
          <div class="card-footer">
            <p class="card-description">{{ card.description }}</p>
            <div class="see-more-button">
              <span>See More</span>
              <img src="@/assets/default/arrow-right-small.svg" alt="arrow" />
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'HomeNameWeek',
  data () {
    return {
      hoveredCard: null,
      nameCards: []
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig'
    ])
  },
  mounted () {
    this.fetchNameOfWeek();
  },
  methods: {
    navigateToFirstCard () {
      if (this.nameCards.length > 0) {
        const firstCard = this.nameCards[0];
        this.$router.push(`/names/${firstCard.name.toLowerCase()}/${firstCard.id}`);
      }
    },
    fetchNameOfWeek () {
      const origin = this.domainConfig?.origin || '';
      this.$global.server.postAPI({
        method: 'get',
        params: {
          origin: origin
        },
        url: '/name/week',
      })
        .then(response => {
          if (response && response.data && response.data.list) {
            const GENDER_COLORS = {
              Boy: 'linear-gradient(180deg, rgba(0, 136, 255, 1) 0%, rgba(0, 136, 255, 0.2) 100%)',
              Girl: 'linear-gradient(180deg, rgba(229, 76, 186, 1) 0%, rgba(229, 76, 186, 0.2) 100%)',
              Unisex: 'linear-gradient(180deg, rgba(200, 173, 23, 1) 0%, rgba(200, 173, 23, 0.2) 100%)'
            };
            this.nameCards = response.data.list.slice(0, 2).map((item, index) => {
              return {
                name: item.name || '',
                pronunciation: item.pronunciation || '',
                description: item.description || '',
                popularity: item.popularity || 'N/A',
                style: item.style || 'N/A',
                meaning: item.meaning || 'N/A',
                meaningList: item.meaningList || [],
                genderIcon: item.gender === 'Boy'
                  ? require('@/assets/icons/male.svg')
                  : item.gender === 'Unisex'
                    ? require('@/assets/icons/unsex.svg')
                    : require('@/assets/icons/female.svg'),
                id: item.id || '',
                background: GENDER_COLORS[item.gender] || GENDER_COLORS.Boy
              };
            });
            console.log('本周名字获取成功:', this.nameCards);
          }
        })
        .catch(error => {
          console.error('获取本周名字失败:', error);
        });
    },
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.home-name-week {
	padding: rem(40) 0;
	display: flex;
	flex-direction: column;
	gap: rem(24);
	align-items: flex-start;
	justify-content: flex-start;
	background: #000;

	.week-header {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		gap: rem(16);
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;

		.week-title {
			color: #ffffff;
			font-size: rem(24);
			line-height: rem(28);
			font-weight: 900;
			cursor: pointer;
		}
	}

	.week-cards {
		padding: 0 rem(180);
		display: flex;
		flex-direction: row;
		gap: rem(24);
		align-items: flex-start;
		justify-content: space-between;
		align-self: stretch;

		.name-card-link {
			text-decoration: none;
			width: calc(50% - rem(12));
			cursor: pointer;

			.name-card {
				border-radius: rem(16);
				padding: rem(24);
				display: flex;
				flex-direction: column;
				gap: rem(16);
				align-items: flex-start;
				justify-content: flex-start;
				width: 100%;
				box-sizing: border-box;
				transition: transform 0.3s ease;

				&:hover {
					transform: translateY(rem(-4));
				}

				.card-header {
					display: flex;
					justify-content: space-between;
					align-self: stretch;

					.card-info {
						.card-name {
							color: #ffffff;
							font-size: rem(28);
							line-height: rem(28);
							font-weight: 900;
						}

						.card-pronunciation {
							color: #ffffff;
							font-size: rem(12);
							line-height: rem(12);
							font-weight: 300;
							font-style: italic;
							margin-top: rem(8);
						}
					}

					.card-gender-icon {
						width: rem(24);
						height: rem(24);
						position: relative;
						flex-direction: column;
						justify-content: center;
						align-items: center;
						gap: rem(10);
						flex-shrink: 0;
						aspect-ratio: 1/1;
						display: flex;
						border-radius: rem(8);
						background: #fff;

						img {
							width: rem(16);
							height: rem(16);
							flex-shrink: 0;
							aspect-ratio: 1/1;
						}
					}
				}

				.card-details-grid {
					display: flex;
					gap: rem(8);
					align-self: stretch;

					.detail-box {
						background: rgba(255, 255, 255, 0.1);
						border-radius: rem(12);
						padding: rem(16);
						display: flex;
						flex-direction: column;
						gap: rem(8);
						justify-content: center;
						flex-grow: 0;
						flex-shrink: 0;

						&:last-child {
							flex-grow: 1;
						}

						.detail-value {
							color: #ffffff;
							font-size: rem(14);
							line-height: rem(14);
							font-weight: 400;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						.detail-label {
							color: #ffffff;
							font-size: rem(12);
							line-height: rem(12);
							font-weight: 300;
						}
					}
				}

				.card-footer {
					display: flex;
					gap: rem(20);
					align-items: flex-end;
					align-self: stretch;

					.card-description {
						color: #ffffff;
						font-size: rem(12);
						line-height: rem(18);
						font-weight: 500;
						flex: 1;
						margin: 0;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						-webkit-box-orient: vertical;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.see-more-button {
						background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
						border-radius: rem(8);
						padding: rem(8) rem(16);
						display: flex;
						gap: rem(8);
						align-items: center;
						justify-content: center;
						width: rem(100);
						box-sizing: border-box;

						span {
							color: #ffffff;
							font-size: rem(12);
							line-height: rem(12);
							font-weight: 700;
						}

						img {
							width: rem(6);
							height: rem(10);
							filter: brightness(0) invert(1);
						}
					}
				}
			}
		}
	}
}

.detect_deviece_mobile {
	.home-name-week {
		padding: rem(40) rem(16);

		.week-header {
			padding: 0;
		}

		.week-cards {
			padding: 0;
			flex-direction: column;

			.name-card-link {
				width: 100%;
			}
		}
		.card-details-grid {
			flex-wrap: wrap;
		}
		.week-cards .name-card-link .name-card .card-details-grid .detail-box {
			flex-grow: 1;
		}
		.week-cards .name-card-link .name-card .card-footer {
			align-items: flex-start;
			flex-direction: column;
		}
	}
}
</style>